import React, { useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';
import styles from './Input.module.css';
import { DURATION, EASE } from '../../utils/motion';

export default function Input({
  label,
  error,
  hint,
  id,
  className = '',
  onFocus,
  onBlur,
  ...props
}) {
  const [focused, setFocused] = useState(false);
  const inputId = id || props.name;
  const describedBy = inputId && (error || hint) ? `${inputId}-msg` : undefined;

  return (
    <div className={`${styles.wrap} ${focused ? styles.focused : ''} ${className}`}>
      {label && (
        <label htmlFor={inputId} className={styles.label}>
          {label}
        </label>
      )}
      <div className={styles.field}>
        <input
          id={inputId}
          className={`${styles.input} ${error ? styles.hasError : ''}`}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          onFocus={(e) => {
            setFocused(true);
            onFocus?.(e);
          }}
          onBlur={(e) => {
            setFocused(false);
            onBlur?.(e);
          }}
          {...props}
        />
        {/* Barra de foco que se expande desde el centro (transform, sin layout) */}
        <motion.span
          className={`${styles.focusBar} ${error ? styles.focusBarError : ''}`}
          aria-hidden="true"
          initial={false}
          animate={{ scaleX: focused ? 1 : 0, opacity: focused ? 1 : 0 }}
          transition={{ duration: DURATION.normal, ease: EASE.out }}
        />
      </div>
      <AnimatePresence initial={false} mode="wait">
        {error ? (
          <motion.span
            key="error"
            id={describedBy}
            className={styles.error}
            role="alert"
            initial={{ opacity: 0, y: -4 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: DURATION.fast, ease: EASE.out }}
          >
            {error}
          </motion.span>
        ) : hint ? (
          <motion.span
            key="hint"
            id={describedBy}
            className={styles.hint}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: DURATION.fast }}
          >
            {hint}
          </motion.span>
        ) : null}
      </AnimatePresence>
    </div>
  );
}
